import "../styles/UpdateCard.css"
export const UpdateCard = ({ photoUrl, message, size }) => {
    return (
        <div className="update-card-container">
            <img src={photoUrl} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
                <div className={`update-card-header`}>
                    {message}
                </div>  
                
        </div>
    )
}